import React, {Fragment} from "react";
import {Step} from "react-joyride";
import styled from "styled-components";
import {useMedia} from "react-use";

const TooltipTitle = styled.h2`
	font-size: 20px;
	font-weight: 700;
	margin-bottom: 7px;
	line-height: 22px;
`;

const TooltipMessage = styled.p`
	font-size: 12px;
	line-height: 24px;

	b {
		font-weight: bold;
	}

	ul {
		list-style: unset;

		li {
			margin-left: 25px;
		}
	}
`;

interface ITooltipContentProps {
	title: string;
	message: string;
	mobileMessage?: string;
}

export const TooltipContent: React.FC<ITooltipContentProps> = ({title, message, mobileMessage}) => {
	const isMobile = useMedia("(max-width: 768px)");

	return (
		<Fragment>
			<TooltipTitle>{title}</TooltipTitle>
			<TooltipMessage
				dangerouslySetInnerHTML={{
					__html: mobileMessage && isMobile ? mobileMessage : message,
				}}
			/>
		</Fragment>
	);
};

export const BOOSTER_STEP: Step = {
	target: ".booster-button",
	content: (
		<TooltipContent
			title="Apply Boosters"
			message="Pick either Triple Captain or Bench Booster to earn more points. Boosters can only be used <b>once per Swing or Phase.</b> You can use <b>1 booster per tournament.</b>"
		/>
	),
	floaterProps: {
		placement: "bottom",
	},
	placement: "bottom",
};
